import { render, staticRenderFns } from "./EuropeanAward.vue?vue&type=template&id=c77e680c&scoped=true"
import script from "./EuropeanAward.vue?vue&type=script&lang=js"
export * from "./EuropeanAward.vue?vue&type=script&lang=js"
import style0 from "./EuropeanAward.vue?vue&type=style&index=0&id=c77e680c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77e680c",
  null
  
)

export default component.exports